import { e } from "mathjs";
import { IGoodsClassifierDTO, IGoodsClassifierViewDTO } from "../../libs/coreapi-dto/dirs/goodsClassifier";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class GoodsClassifierProvider extends DictionaryDataProvider<IGoodsClassifierViewDTO, IGoodsClassifierDTO> {
    
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }
    
    getDataRequest(): Promise<IDictionaryRequest<IGoodsClassifierViewDTO, IGoodsClassifierDTO>> {
        return this._coreApiService.goodsClassifierRequest
    }

    create(entity: IGoodsClassifierDTO, callback?: (idGlobal: string) => void) {
        this._coreApiService.goodsClassifierRequest
            .then(r =>
                r.create(entity, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {

                            callback?.(entity.idGlobal);
                        } catch {
                            callback?.(entity.idGlobal);
                            console.error(e);
                        }
                    } else {
                        callback?.(entity.idGlobal);
                        throw new Error(e.message?.detail);
                    }
                })
            )
            .catch(error => {
                console.error('Request failed:', error);
                callback?.(entity.idGlobal);
            });
    }

    update(id: string, body: IGoodsClassifierDTO, callback?: (e) => void) {
        this._coreApiService.goodsClassifierRequest
            .then(r =>
                r.update(id, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail);
                })
            );
    }

    markDelete(idGlobal: string, callback?: (e) => void) {
        this._coreApiService.goodsClassifierRequest
            .then((r) => {
                r.markDelete(idGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e);
                        } catch (e) {
                            console.error(e)
                        }
                        
                    }
                    else
                        throw new Error(e.message.detail);
                })
            })
    }

    restore(idGlobal: string, callback?: (e) => void) {
        this._coreApiService.goodsClassifierRequest
            .then((r) => {
                r.restore(idGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e);
                        } catch (e) {
                            console.error(e)
                        }
                        
                    }
                    else
                        throw new Error(e.message.detail);
                })
            })
    }

    batchCreate(entities: IGoodsClassifierDTO[], callback?: (result: boolean) => void) {
        this._coreApiService.goodsClassifierRequest
            .then(r =>
                r.batchCreate(entities, (e) => {
                    if (e.respType === 'isCompleted')
                        try {
                            callback?.(e.data);
                        } catch {
                            console.error('ee')
                        }
                    else
                        throw new Error(e.message?.detail);
                })
            );
    }
}